import pre from './pre.js';
import post from './post.js';
import cart from './cart.vue';
import config from './config.vue';
import success from './success.vue';

export default {
    pre,
    components: {
        config,
        cart,
        success,
    },
    post,
}
